export function checkQuizAnswers(elem) {
    
    const question = elem;
    if (!question) return;

    let currentQuestionIndex = 0;
    const userAnswers = [];

    const showQuestion = (index) => {
        question.forEach((q, i) => {
            q.classList.toggle("is-hidden", i !== index);
        });
    };

    showQuestion(currentQuestionIndex);

    question.forEach((elem) => {
        const options = elem.querySelectorAll(".question-panel__option-item");
        const inputs = elem.querySelectorAll(".question-panel__choice-input");
        const feedbackPanel = elem.querySelector(".feedback");
        const nextQuestionButton = elem.querySelector(".js-next-question");
        const introPanel = document.querySelector('.quiz-intro');

        options.forEach((option, index) => {
            option.classList.remove("fade-in");
            option.style.animationDelay = `${index * 450}ms`;
            option.classList.add("fade-in");
        });

        function dimmedAnimation(arr, opt, val) {
            const delayPerOption = 400;
            const pulseDuration = 1200;

            const correctIndex = arr.findIndex((option) => {
                return option.querySelector("input").value === val;
            });

            const totalDelay = correctIndex * delayPerOption + pulseDuration;

            setTimeout(() => {
                opt.forEach((option) => {
                    const input = option.querySelector("input");
                    if (input.value !== val) {
                        option.classList.add("dimmed");
                    }
                });

                if (nextQuestionButton && feedbackPanel) {
                    elem.classList.add('show-feedback');
                    feedbackPanel.classList.add("is-visible");
                    nextQuestionButton.classList.remove("is-hidden");
                    introPanel.classList.add('is-dimmed');
                    document.body.classList.add('overflow-hidden');
                }
            }, totalDelay);
        }

        function checkAnswer(event) {
            const selectedInput = event.target;
            const container = selectedInput.closest('.quiz-question');
            const correctValue = container.dataset.correct;
            const selectedValue = selectedInput.value;
            const isCorrect = selectedValue === correctValue;

            userAnswers.push({
                questionId: container.dataset.questionId,
                selected: selectedValue,
                correct: correctValue,
                isCorrect: isCorrect,
            });

            const options = Array.from(
                container.querySelectorAll(".question-panel__option")
            );

            const sortedOptions = options.sort((a, b) => {
                const aVal = a.querySelector("input").value;
                const bVal = b.querySelector("input").value;
                return (aVal === correctValue) - (bVal === correctValue);
            });

            sortedOptions.forEach((option, index) => {
                const parent = option.parentElement;
                const input = option.querySelector("input");
                const isCorrect = input.value === correctValue;
                const isSelected = input === selectedInput;

                setTimeout(() => {
                    parent.classList.add(isCorrect ? "correct" : "incorrect");
                    parent.classList.remove("fade-in");
                    option.classList.add(isCorrect ? "pulse" : "shake");

                    if (isSelected) {
                        parent.classList.add("was-selected");
                    }

                    input.disabled = true;
                    input.checked = false;
                }, index * 400);
            });

            dimmedAnimation(sortedOptions, options, correctValue);
        }

        inputs.forEach(input => {
            input.addEventListener("change", checkAnswer);
        });
    });

    function clearPreviousQuestion() {
        const options = document.querySelectorAll(".question-panel__choice-input");

        options.forEach((opt) => {
            opt.disabled = false;
            opt.checked = false;
        });
    }

    function handleNextQuestion() {
        const currentPanel = question[currentQuestionIndex];
        const introPanel = document.querySelector('.quiz-intro');
        currentQuestionIndex++;
        clearPreviousQuestion();
        if (currentQuestionIndex < question.length) {
            showQuestion(currentQuestionIndex);
            introPanel.classList.remove('is-dimmed');
            document.body.classList.remove('overflow-hidden');
        } else {
            currentPanel.classList.add("is-hidden");
            document.body.classList.remove('overflow-hidden');
            showHandoff();
        }
    }

    function getScore() {
        return userAnswers.filter(answer => answer.isCorrect).length;
    }

    function saveQuizResults(event, score, totalQuestions) {
        event.preventDefault();
        const quizResults = {
            score,
            total: totalQuestions,
            timestamp: Date.now()
        };

        localStorage.setItem('quizResults', JSON.stringify(quizResults));

        const target = event.currentTarget;
        const redirectUrl = target.getAttribute('data-href');
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
    }

    function showHandoff() {
        const handoffPanel = document.querySelector(".handoff");
        if (!handoffPanel) return;

        const quizIntro = document.querySelector('.quiz-intro');
        const handoffBtn = document.querySelector("[data-show-quiz-results]");
        handoffPanel.classList.remove("is-hidden");
        quizIntro.classList.add('hidden');
        handoffBtn.addEventListener("click", (event) => {
            const questions = document.querySelectorAll('.question-panel');
            const totalQuestions = questions.length;
            const score = getScore();
            saveQuizResults(event, score, totalQuestions);
        });
    }

    const nextButton = document.querySelectorAll(".js-next-question");
    nextButton.forEach((btn) => {
        btn.addEventListener("click", handleNextQuestion, false);
    });
}
